<!-- app-subdomain-creators/src/Components/CreatorChatSearchShowAllLinks.vue -->
<template>
  <div>
    <div v-for="(monthLinks, month) in groupedLinks" :key="month" class="">
      <div class="flex justify-between items-center mb-5">
        <h4 class="text-zinc-500 text-sm font-semibold">{{ month }}</h4>

        <!-- back to menu -->
        <div @click="toggleBackToFiles" class="flex gap-1 cursor-pointer">
          <ArrowLeftIcon class="w-4 text-[#2D8CFF]"></ArrowLeftIcon>
          <div class="text-[#2D8CFF] text-sm font-semibold">
            Back to all Files
          </div>
        </div>
      </div>

      <!-- links list -->
      <div class="flex flex-col gap-2">
        <div
          v-for="(link, index) in monthLinks"
          :key="index"
          class="w-full"
        >
          <CreatorChatLinkPreview
            :url="link.url"
            :title="link.title"
            :created-at="link.createdAt || link.date || null"
            :sender-type="link.senderType"
            :creator-avatar-src="props.creatorAvatarSrc"
            :member-avatar-src="props.memberAvatarSrc"
          />

        </div>
      </div>
    </div>

    <!-- Load more links (paging) -->
    <div v-if="hasMore" class="mt-4 flex justify-center">
      <button
        type="button"
        class="px-3 py-1.5 text-xs font-medium rounded-full bg-zinc-100 text-zinc-600 hover:bg-zinc-200 disabled:opacity-50"
        :disabled="isLoadingMore"
        @click="onLoadMoreClicked"
      >
        <span v-if="!isLoadingMore">Load older links</span>
        <span v-else>Loading…</span>
      </button>
    </div>
    
  </div>
</template>

<script setup>
import { computed, defineProps, defineEmits } from 'vue';
import { ArrowLeftIcon } from '@heroicons/vue/24/outline';
import CreatorChatLinkPreview from '@/Components/CreatorChatLinkPreview.vue';

const props = defineProps({
  searchLinks: {
    type: Array,
    default: () => [],
  },
  hasMore: {
    type: Boolean,
    default: false,
  },
  isLoadingMore: {
    type: Boolean,
    default: false,
  },
  creatorAvatarSrc: {
    type: String,
    default: '',
  },
  memberAvatarSrc: {
    type: String,
    default: '',
  },
});


const emits = defineEmits(['toggleShowAllLinks', 'loadMoreLinks']);

const toggleBackToFiles = () => {
  emits('toggleShowAllLinks');
};

const onLoadMoreClicked = () => {
  emits('loadMoreLinks');
};

// Group links by month, but never drop them if date is weird/missing
const groupedLinks = computed(() => {
  const linksByMonth = {};
  const list = props.searchLinks || [];

  for (const link of list) {
    const rawDate = link.date || link.createdAt || link.timestamp;
    let label = 'Unknown date';

    if (rawDate) {
      const d = new Date(rawDate);
      if (!Number.isNaN(d.getTime())) {
        label = d.toLocaleString('default', {
          month: 'long',
          year: 'numeric',
        });
      }
    }

    if (!linksByMonth[label]) {
      linksByMonth[label] = [];
    }
    linksByMonth[label].push(link);
  }

  return linksByMonth;
});
</script>

